export default {
  namespaced: true,
  state () {
    return {
      isMenuCollapse: true,
      isMuteNotification: localStorage.getItem('isMuteNotification')
    }
  },
  mutations: {
    setIsMenuCollapse(state, payload) {
      state.isMenuCollapse = payload
    },
    setIsMuteNotification(state, payload) {
      state.isMuteNotification = payload
    },
  },
  actions: {
    getIsMenuCollapse({commit}, payload){
      localStorage.setItem('isCollapseMenu', payload);
      commit('setIsMenuCollapse', payload)
    },
    getIsMuteNotification({commit}, payload){
      localStorage.setItem('isMuteNotification', payload);
      commit('setIsMuteNotification', payload)
    }
  },
  getters: {
    isMenuCollapse: (state) => state.isMenuCollapse,
    isMuteNotification: (state) => state.isMuteNotification,
  }
}